// src/components/MarbledPimelodidCatfish.jsx
import React, { useRef, useEffect } from 'react';
import '../../../css/swim.css';

export default function SwimmingMarbledPimelodidCatfish({
  width = 100,
  swimDuration = '30s',
  tailDuration = '0.8s',
  minTop = 80,
  maxTop = 100,
  onClick,
  highlight = false,
  zIndex = 1,
}) {
  const wrapperRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const w = wrapperRef.current;
    const img = imgRef.current;
    if (!w || !img) return;

    // Support reversed ranges
    const low = Math.min(minTop, maxTop);
    const high = Math.max(minTop, maxTop);
    const top = low + Math.random() * (high - low);

    // Position & animate the wrapper (horizontal swim)
    w.style.position = 'absolute';
    w.style.left = '0';
    w.style.top = `${top}%`;
    w.style.width = `${width}px`;        // snug hitbox so highlight ring fits
    w.style.animationDuration = swimDuration;
    w.style.zIndex = String(zIndex);

    // Animate the image (tail wag)
    img.style.animationDuration = tailDuration;
  }, [swimDuration, tailDuration, minTop, maxTop, width, zIndex]);

  const url = '/images/animals/50_80m/predator/marbled_pimelodid_catfish_head.png';

  const handleKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      ref={wrapperRef}
      className={`swim-boto-wrapper ${highlight ? 'inline-block ring-4 ring-yellow-300 rounded-full scale-110' : ''}`}
      // wrapper is clickable; don't disable pointer events
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label="Marbled Pimelodid Catfish"
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <img
        ref={imgRef}
        src={url}
        alt="Marbled Pimelodid Catfish"
        className="swim-boto-img"
        draggable={false}
        style={{
          width: `${width}px`,
          display: 'block',
          cursor: onClick ? 'pointer' : 'default',
        }}
        onError={(e) =>
          console.warn('[MarbledPimelodidCatfish] image failed to load:', e.currentTarget.src)
        }
      />
    </div>
  );
}
